import React from 'react'

export const Facebook: React.FC = () => {
  return (
    <path d="M12 9H9.65625V16H6.53125V9H4V6.09375H6.53125V3.90625C6.53125 3.07292 6.6875 2.36458 7 1.78125C7.3125 1.19792 7.75 0.760417 8.3125 0.46875C8.89583 0.15625 9.5625 0 10.3125 0C10.6458 0 11 0.0208333 11.375 0.0625C11.75 0.0833333 12.0417 0.114583 12.25 0.15625L12.5625 0.1875V2.65625H11.3125C10.7292 2.65625 10.3021 2.8125 10.0312 3.125C9.78125 3.41667 9.65625 3.78125 9.65625 4.21875V6.09375H12.4375L12 9Z" />
  )
}

export default Facebook
